import Modal from '~/components/Modal';
import { Button } from '~/components';
import BudgetTable from '~/features/projectReview/components/BudgetTable';

export interface BidConfirmationModalProps {
  closeModal: Function;
  submitBid: Function;
  submitBidStatus: string;
  budgetDisplayValues: any;
  modalPricingType:'ACQUISITION' | 'OFFTAKE' | 'ITC' | 'DEV_FEE' | 'BRIDGE_LOAN';
  isEpcOperating: boolean;
  project: any;
  formState: any;
}

export default function BidConfirmationModal({
  closeModal,
  submitBid,
  submitBidStatus,
  budgetDisplayValues,
  project,
  formState
}: BidConfirmationModalProps) {

  return (
  <Modal closeModal={submitBidStatus === 'loading' ? undefined : closeModal}>
    <Modal.Title>Confirm your bid</Modal.Title>
    <Modal.Content>
      <p>Your bid details are presented below for your review.</p>
      <BudgetTable 
        project={project}
        formState={formState}
        viewMode='table'
      />
    </Modal.Content>
    <Modal.Footer>
      <Button 
        outlined 
        primary 
        onClick={() => closeModal()}
      >
        Cancel
      </Button>
      <Button 
        primary 
        onClick={async () => {
          await submitBid();
          closeModal();
        }}
        disabled={submitBidStatus === 'loading'} 
        loading={submitBidStatus === 'loading'}
      >
        Confirm bid
      </Button>
    </Modal.Footer>
</Modal>

  );
}